/* eslint-disable */
export default {
  _click: 'click',
  _CorrectMark: 'CorrectMark',
  _hint_marble_math: 'hint-marble-math',
  _IncorrectMark: 'IncorrectMark',
  _LevelUp: 'LevelUp',
  _MarbleSound: 'MarbleSound',
  _PenguinRun: 'PenguinRun',
  _PlacedSound: 'PlacedSound',
  _RemovedSound: 'RemovedSound',
  _SlideWhistleSound: 'SlideWhistleSound',
  _ThemeSound: 'ThemeSound',
}